import { useCastScreenStore } from "@/stores/cast-screen/index.ts";
import { setBodyDataTheme } from "@/util/useThemeInitializer.ts";

export default function useCastScreenData() {
  const castScreenStore = useCastScreenStore();

  async function loadCastScreenData(params: Record<string, string>) {
    try {
      // /cast-screen/ is a non-initialized route, so we need to
      // manually set the data-theme attribute to light in order
      // to have the global variables set correctly.
      setBodyDataTheme(false);

      await castScreenStore.initialize(params);
    } catch (err) {
      console.log(err);
    }
  }

  return {
    loadCastScreenData,
  };
}
